<template>
  <div :class="{'ismobile':isMobile}">
    <page-header></page-header>
    <el-card class="msg-card">
      <el-tabs v-model="activeTab">
        <el-tab-pane name="alert">
          <span class="header-label" slot="label"> 报警</span>
        </el-tab-pane>
        <el-tab-pane name="notice">
          <span class="header-label" slot="label"> 通知</span>
        </el-tab-pane>
        <el-tab-pane name="announcement">
          <span class="header-label" slot="label"> 公告</span>
        </el-tab-pane>
      </el-tabs>
      <div>
        <div v-for="msgItem in msgList" class="msg-item">
          <div style="align-self: flex-start;">
            <el-checkbox v-model="checked"></el-checkbox>
          </div>
          <p>这是一条长长的{{activeTab}}这是一条长长的{{activeTab}}这是一条长长的{{activeTab}}这是一条长长的{{activeTab}}这是一条长长的{{activeTab}}</p>
          <p>2011-11-05 05:11:11</p>

        </div>

      </div>
      <transition name="el-zoom-in-bottom">
        <div v-show="checked" class="tool-bar">
          <div>
            <el-button size="large" type="danger">删除</el-button>
            <el-button size="large">取消</el-button>
          </div>

        </div>
      </transition>

    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import pageHeader from '../../components/tempControl/header'

export default {
  name: 'msgList',
  components: {
    pageHeader
  },
  data() {
    return {

      checked: "",
      activeTab: "notice",
      msgList: 4
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile
    }),
  },
  created() {

  },
  methods: {



  }

}
</script>

<style scoped>
.header-label {
  font-size: .24rem;
  color: #000;
  width: 110px;
  text-align: center;

  display: inline-block;
}

.ismobile .header-label {
  font-size: .15rem;
  color: #000;
  width: 50px;
  text-align: center;

  display: inline-block;
}

.msg-item {
  display: flex;
  margin: 10px 0;
  padding: 30px 47px 26px;
  align-items: center;
  border-bottom: 1px solid #ccc
}

.ismobile .msg-item {
  display: flex;
  margin: 10px 0;
  padding: 10px 10px;
  align-items: center;
}

.msg-item>p:first-child {
  font-size: 0.18rem;
  margin-right: 100px;
  min-width: 200px;
}

.ismobile .msg-item>* {
  margin: 0 5px
}

.msg-item>* {
  margin: 0 50px
}

.tool-bar {
  position: fixed;
  z-index: 9;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background: #ffffff;
  display: flex;
  box-shadow: 4px -1px 12px 1px rgba(0, 0, 0, 0.3);
  align-items: center;
  justify-content: flex-end;
}

.tool-bar>div {
  margin-right: 50px
}
</style>
<style>
.msg-card .el-tabs__item {
  margin-top: 17px;
  margin-bottom: 8px;
}

.ismobile .el-tabs__item {
  margin: 0px;
}

.msg-card .el-card__body {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// msgList.vue?12df52be